const ContactsPage = () => {
  return (
    <>
      <h1>Contacts Page</h1>
    </>
  );
};

export default ContactsPage;
